/**
 * Team Modal Module
 * Handles opening and closing of team member modals
 */

export default class TeamModal {
    constructor() {
        this.modal = null;
        this.modalOverlay = null;
        this.isOpen = false;
        this.init();
    }

    init() {
        // Create modal structure
        this.createModal();

        // Bind event listeners
        this.bindEvents();
    }

    createModal() {
        // Create modal overlay
        this.modalOverlay = document.createElement('div');
        this.modalOverlay.className = 'team-modal-overlay';
        this.modalOverlay.setAttribute('data-team-modal-overlay', '');

        // Create modal
        this.modal = document.createElement('div');
        this.modal.className = 'team-modal';
        this.modal.setAttribute('data-team-modal', '');
        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-modal', 'true');
        this.modal.setAttribute('aria-labelledby', 'team-modal-title');

        // Create modal content
        this.modal.innerHTML = `
            <button class="team-modal__close" data-team-modal-close aria-label="Close modal">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="team-modal__content">
                <div class="team-modal__image-container">
                    <img class="team-modal__image" src="" alt="" />
                </div>
                <div class="team-modal__details">
                    <h2 class="team-modal__name" id="team-modal-title"></h2>
                    <p class="team-modal__role"></p>
                    <div class="team-modal__bio"></div>
                </div>
            </div>
        `;

        // Append to body
        document.body.appendChild(this.modalOverlay);
        document.body.appendChild(this.modal);
    }

    bindEvents() {
        // Team card click handlers
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-team-modal-trigger]');
            if (trigger) {
                e.preventDefault();
                this.openModal(trigger);
            }
        });

        // Close button
        const closeBtn = this.modal.querySelector('[data-team-modal-close]');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.closeModal());
        }

        // Overlay click
        this.modalOverlay.addEventListener('click', () => this.closeModal());

        // Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.closeModal();
            }
        });
    }

    openModal(trigger) {
        // Get team ID from trigger
        const teamId = parseInt(trigger.dataset.teamId);

        // Get team data from global object
        if (!window.teamMembersData) {
            console.error('Team data not found');
            return;
        }

        const teamMember = window.teamMembersData.find(member => member.id === teamId);

        if (!teamMember) {
            console.error('Team member not found:', teamId);
            return;
        }

        const { name, role, bio, image } = teamMember;

        // Populate modal
        const modalImage = this.modal.querySelector('.team-modal__image');
        const modalName = this.modal.querySelector('.team-modal__name');
        const modalRole = this.modal.querySelector('.team-modal__role');
        const modalBio = this.modal.querySelector('.team-modal__bio');

        if (modalImage && image.url) {
            modalImage.src = image.url;
            modalImage.alt = image.alt || name;
            if (image.width) modalImage.width = image.width;
            if (image.height) modalImage.height = image.height;
        }

        if (modalName) modalName.textContent = name || '';
        if (modalRole) modalRole.textContent = role || '';
        if (modalBio) modalBio.textContent = bio || '';

        // Show modal
        this.modalOverlay.classList.add('is-active');
        this.modal.classList.add('is-active');
        document.body.classList.add('lock');
        this.isOpen = true;

        // Focus trap
        this.modal.focus();
    }

    closeModal() {
        this.modalOverlay.classList.remove('is-active');
        this.modal.classList.remove('is-active');
        document.body.classList.remove('lock');
        this.isOpen = false;
    }
}
